import { Button, Form } from "antd";
import { RegisterationText } from "texts/registerationText";
import { ArrowLeftIconOutline } from "../icons";
import { useEffect, useState } from "react";
import ImageUpload from "../_atoms/ImageUpload";
import { generalTexts } from "texts/generalTexts";

interface Props {
  nextStepHandler: (value) => void;
  prevStepHandler: () => void;
  value: any;
}
const RegisterStep3 = ({ nextStepHandler, prevStepHandler, value }: Props) => {
  const [form] = Form.useForm();
  const [validationErrorFeilds, setValidationErrorFeilds] = useState(null);
  const [formData, setFormData] = useState({
    nationalImage: null,
    pharmacyLicense: null,
    technicalAssistantLicense: null,
  });
  useEffect(() => {
    setFormData({ ...formData, ...value });
  }, []);
  const onFinish = () => {
    setFormData({ ...formData, ...value });
    if (formData?.pharmacyLicense !== null && formData?.technicalAssistantLicense !== null) {
      nextStepHandler(formData);
      setValidationErrorFeilds(null);
    } else {
      setValidationErrorFeilds(formData);
    }
  };
  return (
    <div className="w-full">
      <p className="text-center text-sm font-medium pb-8">{RegisterationText?.uploadMediaInfo}</p>
      <Form form={form} className="flex flex-col gap-y-6" layout="vertical" onFinish={onFinish} autoComplete="off">
        <ImageUpload
          title={RegisterationText?.nationalImage}
          name="nationalImage"
          previewImageUrl={formData?.nationalImage ? URL.createObjectURL(formData?.nationalImage) : null}
          setPreviewImageUrl={setFormData}
        />
        <ImageUpload
          validationError={validationErrorFeilds?.pharmacyLicense === null}
          required
          title={RegisterationText?.pharmacyLicense}
          name="pharmacyLicense"
          previewImageUrl={formData?.pharmacyLicense ? URL.createObjectURL(formData?.pharmacyLicense) : null}
          setPreviewImageUrl={setFormData}
        />
        <ImageUpload
          validationError={validationErrorFeilds?.technicalAssistantLicense === null}
          title={RegisterationText?.technicalAssistantLicense}
          required
          name="technicalAssistantLicense"
          previewImageUrl={formData?.technicalAssistantLicense ? URL.createObjectURL(formData?.technicalAssistantLicense) : null}
          setPreviewImageUrl={setFormData}
        />
        <div className="flex gap-x-3 w-full">
          <Button type="text" className="bg-white flex justify-center items-center gap-x-1 text-black border-black w-full !px-2" onClick={() => prevStepHandler()} size="large">
            {generalTexts?.returnToBeforePage}
            <ArrowLeftIconOutline width={24} height={24} stroke="black" />
          </Button>
          <Button type="text" className="bg-black flex justify-center items-center gap-x-1 text-white border-black w-full !px-2" htmlType="submit" size="large">
            {generalTexts?.confirmAndContinu}
            <ArrowLeftIconOutline width={24} height={24} stroke="white" />
          </Button>
        </div>
      </Form>
    </div>
  );
};
export default RegisterStep3;
